import React from "react";
import { FetchPostgresViewer } from "types/gql-types";

const Context = React.createContext<FetchPostgresViewer["viewerPostgres"]>(null);
Context.displayName = "ViewerPostgres";

export const Login = React.createContext({ onLogin: () => {} });


export const useViewer = () => {
  const context = React.useContext(Context);
  // eslint-disable-next-line no-undefined
  if (context === undefined) {
    throw new Error("useViewer must be used within a ViewerProvider");
  }
  return context;
};

export default Context;
